import Link from "next/link";
import styles from "./BreadCrumbs.module.css";

type BreadCrumbsProps = {
  list: string[];
  urls: string[];
};

export default function BreadCrumbs(props: BreadCrumbsProps) {
  const mapped = props.list.map((val, index) => {
    if (props.list.length === 1) {
      return (
        <p
          className={
            index === props.list.length - 1 ? styles.lastCrumb : styles.crumb
          }
          key={val}
        >
          {val}
        </p>
      );
    } else if (index !== props.list.length - 1) {
      return (
        <>
          <Link
            href={props.urls[index]}
            key={val}
            className={
              index === props.list.length - 1 ? styles.lastCrumb : styles.crumb
            }
          >
            {val}
          </Link>
          {index !== props.list.length - 1 && (
            <span className={styles.seperator}>/</span>
          )}
        </>
      );
    } else {
      return (
        <>
          <p
            key={val}
            className={
              index === props.list.length - 1 ? styles.lastCrumb : styles.crumb
            }
          >
            {val}
          </p>
          {index !== props.list.length - 1 && (
            <span className={styles.seperator}>/</span>
          )}
        </>
      );
    }
  });
  return <div className={styles.main}>{mapped}</div>;
}
